// Building Sections — ASTM Uniformat II (Level 1 Categories -> Level 2 Subcategories).
// Single source of truth: used by BuildingSectionsAccordion (WBLCA tab, Building Workspace)
// and by BuildingMaterialCompositionTable's Products dropdown (Building Circularity),
// so both stay in sync automatically if this structure ever changes.
export const BUILDING_SECTIONS = [
  {
    id: "substructure",
    name: "Substructure",
    code: "A",
    subcategories: [
      { id: "foundations", name: "Foundations", code: "A10" },
      { id: "basement_construction", name: "Basement Construction", code: "A20" },
    ],
  },
  {
    id: "shell",
    name: "Shell",
    code: "B",
    subcategories: [
      { id: "superstructure", name: "Superstructure", code: "B10" },
      { id: "exterior_enclosure", name: "Exterior Enclosure", code: "B20" },
      { id: "roofing", name: "Roofing", code: "B30" },
    ],
  },
  {
    id: "interiors",
    name: "Interiors",
    code: "C",
    subcategories: [
      { id: "interior_construction", name: "Interior Construction", code: "C10" },
      { id: "stairs", name: "Stairs", code: "C20" },
      { id: "interior_finishes", name: "Interior Finishes", code: "C30" },
    ],
  },
  {
    id: "services",
    name: "Services",
    code: "D",
    subcategories: [
      { id: "conveying", name: "Conveying", code: "D10" },
      { id: "plumbing", name: "Plumbing", code: "D20" },
      { id: "hvac", name: "HVAC", code: "D30" },
      { id: "fire_protection", name: "Fire Protection", code: "D40" },
      { id: "electrical", name: "Electrical", code: "D50" },
    ],
  },
  {
    id: "equipment_furnishings",
    name: "Equipment & Furnishings",
    code: "E",
    subcategories: [
      { id: "equipment", name: "Equipment", code: "E10" },
      { id: "furnishings", name: "Furnishings", code: "E20" },
    ],
  },
];
